const isLinux = String(navigator.platform).indexOf("Linux") > -1;

export { isLinux }